<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="ch00_fm01_half1"></a><a id="page_1"></a><strong>STICK-TO-IT-IVENESS</strong></p>
<p class="bsubtitlecenter"><strong>Inspirations to Get You Where You Want to Go</strong></p>
<p class="authorcenter">Addie Johnson</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01_half1.vue?85ba2a8c